<!-- 行业 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add">新增</el-button>
        </template>
      </dynamic-search>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="行业"
        :enableDrag="true"
        width="500px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="formConfig"
          v-model="form"
          :look="openLook"
          @submit="submit"
          @cancelForm="cancel"
          :disabled="openLook"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :edit-rules="validRules"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
        :showNumber="true"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" style="color:#4084B7" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DragDialog from "@/components/DragDialog";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import { addIndustry, deleteIndustry, editIndustry } from "@/api/industry";

export default {
  name: "Industry",
  components: {
    DynamicSearch,
    DragDialog
  },
  mixins: [DataTableMixin],
  data() {
    return {
      delLoading: false,
      openLook: false,
      form: {},
      dialogVisible: false,
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "行业代码",
            value: "",
            rules: [
              { required: true, message: "行业代码不能为空", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "行业代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "textarea",
            maxlength: "100",
            showWordLimit: true,
            key: "name",
            label: "行业名称",
            value: "",
            placeholder: "请输入行业名称",
            rules: [
              { required: true, message: "行业名称不能为空", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "行业代码",
          editRender: { name: "ElInput" }
        },
        {
          prop: "name",
          label: "行业名称",
          editRender: { type: "number", name: "ElInputNumber" },
          query: {
            type: "input"
          }
        },
        {
          prop: "remark",
          label: "备注",
          editRender: { type: "default" }
        }
      ],
      validRules: {
        id: [{ required: true, message: "请输入键值", trigger: "blur" }],
        name: [{ required: true, message: "行业名称不能为空", trigger: "blur" }],
        remark: [{ required: true, message: "备注不能为空", trigger: "blur" }]
      },
      tableData: [
        {
          code: "i007",
          name: "建筑业",
          remark: "房地产"
        }
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    cancel() {
      this.dialogVisible = false;
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/industry`;
      const premType = "3,4"; // 权限类型【前端权限】
      const params = { page: this.page, size: this.offset, type: premType };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 删除
    del(row) {
      // console.log(row);
      this.delLoading = true;
      deleteIndustry(row.id)
        .then(() => {
          this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.delLoading = false;
        })
        .catch(() => {
          this.delLoading = false;
        });
    },
    // 新增
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    // 修改
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    // 提交 （添加/修改）
    submit() {
      if (this.form.id) {
        editIndustry(this.form).then(res => {
          this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addIndustry(this.form).then(res => {
          this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
